import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { DataModelComponent } from '../../../../models/data.model.component';
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model';
import { UsersService } from '../../../../models/usuarios.service';
import { PrinterService } from '../../services/printer.service';

@Component({
    selector: 'monitor-item',
    templateUrl: './monitor-item.html',
    styleUrls: ['./monitor-item.css']
})
export class MonitorItemComponent extends DataModelComponent<any>
    implements OnInit {
    canModify = true;
    private pedidoModel: CarrinhoItemsModel;
    fDataPedido: Date = (new Date());

    pedidos_ = []
    @Input()
    get filtroPedido() {
        return this.fDataPedido;
    }
    set filtroPedido(x) {
        this.filtroPedido = x;
        if (x) {
            this.pedidoModel.carregarPedidos(this.users.fornecedor, this.oldCodigo, x);
        }
    }

    @Input()
    estadoBase = 1;

    @Input()
    pesquisaValue: string = ''

    @Input()
    get pedidos() {
        return this.pedidoModel.pedidos.sort(function (a, b) { return ((a.pedido < b.pedido) ? 1 : (a.pedido > b.pedido) ? -1 : 0) });
    }
    set pedidos(value: Array<any>) {
        this.pedidos_ = value
    }

    private oldCodigo: string = "";
    @Input()
    estado: any;


    @Input()
    get value() {
        return this.estado;
    }
    set value(estado) {
        this.estado = estado;
        this.carregar(estado.codigo);
    }
    formatQtde(valor) {
        return CarrinhoItemsModel.formatQtde(valor);
    }
    getItemsCount(pedido) {
        return CarrinhoItemsModel.getItemsCount(pedido);
    }
    getPesoTotal(pedido) {
        return CarrinhoItemsModel.getPesoTotal(pedido);
    }
    constructor (private db: AngularFirestore,
        private users: UsersService,
        private ptrSvc: PrinterService
    ) {
        super({});
        this.pedidoModel = new CarrinhoItemsModel(db, this.users);

    }


    okDlg(msg) {
        alert(msg);
    }

    ngOnInit(): void {
        this.estado = this.estadoBase;

    }

    carregar(cod_estado) {
        this.canModify = this.users.isFornecedor || this.users.isGestor;
        this.pedidoModel.carregarPedidos((this.users.isAdmin ? 0 : this.users.fornecedor), cod_estado, this.fDataPedido);
        this.oldCodigo = cod_estado;
    }

    getIcon(ped) {
        return 'alert';
    }


    onClickDecrease(idx) {
        if (this.canModify)
            this.pedidoModel.DoEstadoDecrease(idx);
    }
    onClickIncrease(idx) {
        if (this.canModify)
            this.pedidoModel.DoEstadoIncrease(idx);
    }

    getNomeEstadoAnterior(idx) {
        let estado = this.getEstado(idx);
        let est = this.pedidoModel.localizaEstadoAnterior(estado);
        return (est ? 'p/' + est.nome : 'Voltar Item');
    }

    getNomeEstadoProximo(idx) {
        let codigo = this.getEstado(idx);
        let estado = this.pedidoModel.localizaEstado(codigo);
        let est = this.pedidoModel.localizaEstado(estado.proximo);
        return (est ? 'p/' + est.nome : 'Voltar Item');
    }


    getEstado(idx) {
        let pedido = this.pedidoModel.pedidos[idx];
        return pedido.items[0].estado;
    }

    onClickDespachado(idx) {
        if (this.canModify) {
            let pedido = this.pedidoModel.pedidos[idx];
            this.pedidoModel.alterarEstadoTodos(idx, pedido.items[0].estado < 800 ? 800 : 900);
        }
    }

    DoMudarEstados(idx, para) {
        if (this.canModify) {
            let pedido = this.pedidoModel.pedidos[idx];
            console.log('mudar estado: ', pedido);
            this.pedidoModel.alterarEstadoTodos(idx, para);
            if (para == 800 || para == 900) {
                this.pesquisaValue = '';
            }
        }
    }

    getCaptionConcluido(idx) {
        let pedido = this.pedidoModel.pedidos[idx];
        return (pedido.items[0].estado < 800 ? "Despachado" : "Entregue");
    }

    marcarTodos($event, idx) {
        let todos = $event.checked;

        let pedido = this.pedidoModel.pedidos[idx];
        pedido.items.forEach(element => {
            element.checked = todos;
        });
    }

    imprimirPedido(nPedido) {
        let arr = this.pedidos.filter((elem) => (elem.pedido == nPedido))
        if (arr && (arr.length > 0)) {
            this.ptrSvc.printPedido(arr[0].items)
        }
    }

}
